import React from 'react'
import {pathsA, pathsB} from './utils'

export const LoaderIcon = () => {
  return (
    <div id="main-loading" className="loading">
      <div className="loader flex flex-col items-center">
        <svg
          width="89"
          height="89"
          viewBox="0 0 89 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            {pathsA.map((path, index) => {
              return (
                <Path
                  key={`${path.i}.${index}`}
                  i={path.i}
                  d={path.d}
                  className="loader-blue-part"
                />
              )
            })}
          </g>
          <g>
            {pathsB.map((path, index) => {
              return (
                <Path
                  key={`${path.i}.${index}`}
                  i={path.i}
                  d={path.d}
                  className="loader-orange-part"
                />
              )
            })}
          </g>
        </svg>
      </div>
    </div>
  )
}

const Path = ({i, d, className}: {i: number; d: string; className: string}) => {
  const currentStyle: Record<string, number> = {
    '--i': i
  }

  return <path className={className} style={currentStyle} d={d} />
}
